// extracted by mini-css-extract-plugin
export default {"image":"Logotype_image__slfeZ","App-logo-spin":"Logotype_App-logo-spin__CVuDv"};